// client/src/pages/Admin/ActivityLog/constants/activity.constants.ts

import { ActivityAction, ActivitySeverity } from '../types/activity.types';

export const ACTION_LABELS: Record<ActivityAction, string> = {
    login: 'User Login',
    logout: 'User Logout',
    login_failed: 'Failed Login Attempt',
    password_reset: 'Password Reset',
    password_changed: 'Password Changed',
    resource_created: 'Resource Created',
    resource_updated: 'Resource Updated',
    resource_deleted: 'Resource Deleted',
    resource_published: 'Resource Published',
    resource_archived: 'Resource Archived',
    project_created: 'Project Created',
    project_updated: 'Project Updated',
    project_deleted: 'Project Deleted',
    project_published: 'Project Published',
    project_archived: 'Project Archived',
    donation_created: 'Donation Created',
    donation_updated: 'Donation Updated',
    donation_deleted: 'Donation Deleted',
    donation_status_changed: 'Donation Status Changed',
    contact_status_changed: 'Contact Status Changed',
    contact_replied: 'Contact Replied',
    category_created: 'Category Created',
    category_updated: 'Category Updated',
    category_deleted: 'Category Deleted',
    payment_method_created: 'Payment Method Created',
    payment_method_updated: 'Payment Method Updated',
    payment_method_deleted: 'Payment Method Deleted',
    system_error: 'System Error',
    system_warning: 'System Warning',
};

export const ACTION_ICON_NAMES: Record<ActivityAction, string> = {
    login: 'LogIn',
    logout: 'LogOut',
    login_failed: 'AlertCircle',
    password_reset: 'KeyRound',
    password_changed: 'Lock',
    resource_created: 'FilePlus',
    resource_updated: 'FileEdit',
    resource_deleted: 'FileMinus',
    resource_published: 'CheckCircle',
    resource_archived: 'Archive',
    project_created: 'FolderPlus',
    project_updated: 'FolderEdit',
    project_deleted: 'FolderMinus',
    project_published: 'CheckCircle',
    project_archived: 'Archive',
    donation_created: 'HandCoins',
    donation_updated: 'Edit',
    donation_deleted: 'Trash2',
    donation_status_changed: 'RefreshCw',
    contact_status_changed: 'RefreshCw',
    contact_replied: 'Mail',
    category_created: 'Tag',
    category_updated: 'Edit',
    category_deleted: 'Trash2',
    payment_method_created: 'CreditCard',
    payment_method_updated: 'Edit',
    payment_method_deleted: 'Trash2',
    system_error: 'XCircle',
    system_warning: 'AlertTriangle',
};

export const SEVERITY_LABELS: Record<ActivitySeverity, string> = {
    info: 'Info',
    warning: 'Warning',
    error: 'Error',
    critical: 'Critical',
};

export const SEVERITY_COLORS: Record<ActivitySeverity, string> = {
    info: 'blue',
    warning: 'yellow',
    error: 'red',
    critical: 'red',
};

export const SEVERITY_ICON_COLORS: Record<ActivitySeverity, string> = {
    info: '#3B82F6',
    warning: '#F59E0B',
    error: '#EF4444',
    critical: '#DC2626',
};
